<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-minus</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.divider') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical style="margin: 0 10px 0 10px;" />
      <template>        
       <h5 style="font-weight: normal;color:rgba(0, 0, 0, 0.47);font-size: 16px">{{$t('divider.space')}}</h5>
      </template>
    </v-toolbar>
    <v-layout
      wrap
      :style="{ 'margin-top': !collapseContent ? '-25px': '0'}"
    >
      <v-flex xs6>
        <v-slider
          v-show="!collapseContent"
          style="padding-top: 20px"
          v-model="content.DividerUp"
          :color="enterpriseColor"
          prepend-icon="mdi-menu-up"
          min="0"
          max="100"
          thumb-label
          @input="handleChangeIsModified"
        />
      </v-flex>
      <v-flex xs6>
        <v-slider
          v-show="!collapseContent"
          style="padding-top: 20px"
          v-model="content.DividerDown"
          :color="enterpriseColor"
          append-icon="mdi-menu-down"
          min="0"
          max="100"
          thumb-label
          @input="handleChangeIsModified"
        />
      </v-flex>
      <v-flex
        xs6
        :style="{ 'margin-top': !collapseContent ? '-30px': '0'}"
      >
        <v-slider
          v-show="!collapseContent"
          style="padding-top: 20px"
          v-model="content.DividerLeft"
          :color="enterpriseColor"
          prepend-icon="mdi-menu-left"
          min="0"
          max="100"
          thumb-label
          @input="handleChangeIsModified"
        />
      </v-flex>
      <v-flex
        xs6
        :style="{ 'margin-top': !collapseContent ? '-30px': '0'}"
      >
        <v-slider
          v-show="!collapseContent"
          style="padding-top: 20px"
          v-model="content.DividerRight"
          :color="enterpriseColor"
          append-icon="mdi-menu-right"
          min="0"
          max="100"
          thumb-label
          @input="handleChangeIsModified"
        />
      </v-flex>
      <v-flex xs12
        v-if="!collapseContent"
      >
        <v-checkbox
          v-model="content.DividerDark"
          label="Dark"
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  export default {
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseColor() {
        return this.$store.state.app.enterpriseColor
      }
    },
    mounted () {
      if (this.content.isNew) this.handleChangeIsModified()
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      },
    }
  }
</script>

<style scoped>
  .v-label theme--light {
    width: 1000px !important;
  }
</style>

